import { getIdFromUrl } from '@sonifi/wb-core/utils/parseHelper';
import { hasDeletedContent } from '../../store/hotelDirectorySliceHelper';
import { findNodeById } from '@sonifi/wb-tree/utils/helper';

export const createHotelDirectoryTree = ({
  menu,
  embedded,
  mediaDependencies,
}) => {
  const screen = embedded[menu.screen];
  return {
    ...menu,
    // TODO: the fact that we are copying all attributes onto the returned object,
    //       plus adding `subject` and `screen` is inefficient. We should refactor
    //       to remove all of this redudant data.
    ...screen,
    subject: screen,
    screen,
    hasDeletedContent: hasDeletedContent({
      screen,
      mediaDependencies,
    }),
    embeddedResourceLastUpdate: screen?.regions?.reduce?.((acc, region) => (
      region?.content?.length
        ? region.content.reduce((targetUpdated, content) => (
          content.target && embedded[content.target]
            ? Math.max(new Date(embedded[content.target].last_updated), targetUpdated || 0)
            : targetUpdated
        ), acc)
        : acc
    ), null),
    indicatorImage: {
      showIcon: false,
      showTooltip: false,
    },
    secondaryValue: '',
    children: menu.children?.map?.((child) => (
      createHotelDirectoryTree({
        menu: child,
        embedded,
        mediaDependencies
      })
    ))
  };
};

export const buildMediaParam = (mediaData, mediaKey) => {
  const ids = [];

  Object.values(mediaData).forEach((value) => {
    if (value?.regions?.length) {
      value.regions
        .filter((region) => region?.content)
        .forEach(({ content }) => {
          if (Array.isArray(content)) {
            content.forEach((val) => {
              if (val?.image && mediaKey.toLowerCase() === 'images') {
                const id = getIdFromUrl({ url: val.image, parseToInt: false });
                ids.push(id);
              }
            });
          } else {
            Object.values(content).forEach((val) => {
              const lastSlashIndex = val.target?.lastIndexOf('/');
              if (lastSlashIndex && mediaKey.toLowerCase() === `${val.type}s`) {
                const id = getIdFromUrl({ url: val.target, parseToInt: false });
                ids.push(id);
              }
            });
          }
        });
    }
  });
  return Array.from(new Set(ids)).join(',');
};

export const updateHDTreeByMediaDependencies = ({
  menu,
  mediaDependencies,
}) => {
  menu.children.forEach((ch, index) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      updateHDTreeByMediaDependencies({
        menu: menu.children[index],
        mediaDependencies,
      });
    }

    menu.children[index] = {
      ...ch,
      hasDeletedContent: hasDeletedContent({
        screen: ch.screen,
        mediaDependencies,
      }),
    };
  });

  return menu;
};

export const buildMediaDataForMediaDependencies = ({
  menu,
  mediaData = [],
}) => {
  mediaData[menu.screen.uri] = menu.screen; // For Root
  menu.children.forEach((ch) => {
    if (ch.children && Array.isArray(ch.children) && ch.children.length) {
      buildMediaDataForMediaDependencies({ menu: ch, mediaData });
    }
    mediaData[ch.screen.uri] = ch.screen;
  });
  return mediaData;
};

export const getInicialNode = ({ id, menu }) => {
  const node = id ? findNodeById({ menu, nodeId: parseInt(id) }) : menu;

  return node;
};
